import DefaultMoment from "moment";

const fixTime = value => {
  if (value.length === 2 || value.length === 5 || value.length === 8) {
    // Split hh:mm:ss to hh
    if (value.length === 2) {
      const fixedTime = value.split(":");
      return DefaultMoment(fixedTime, "HH").format("HH");
    } else if (value.length === 5) {
      // Split hh:mm:ss to hh:mm
      const fixedTime = value.split(":");
      return DefaultMoment(fixedTime, "HH:mm").format("HH:mm");
    } else if (value.length === 8) {
      // Split hh:mm:ss to hh:mm:ss
      const fixedTime = value.split(":");
      return DefaultMoment(fixedTime, "HH:mm:ss").format("HH:mm:ss");
    }
  }
};

export default fixTime;
